import React, { useContext, useEffect, useState } from 'react'
import { Button } from 'reactstrap'
import { Link, useNavigate } from 'react-router-dom'
import { Table } from 'antd'
import { Nav } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import FeatherIcon from 'feather-icons-react'

import { deleteTemplate, getAllTemplate } from '../../redux/slices/templateSlice'
import { itemRender } from '../../helper/paginationfunction'
import { SpinnerContext } from '../../context/spinnerContext'
import { errorToast, successToast } from '../../util/Toast/toast'
import { CLEANER, CLIENT } from '../../util/constant'
import CustomModal from '../../component/customModal'
import DeletePopup from '../../component/deletePopup'

import EmailAddEditModal from './EmailAddEditModal'
import { getUserRole, hasAccess } from '../../helper/function'

const Emails = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { changeLoader } = useContext(SpinnerContext)
  const { templatesData } = useSelector((state) => state.templates)

  const [currentPage, setCurrentPage] = useState(1)
  const [showModal, setShowModal] = useState(false)
  const [pagesize, setPagesize] = useState(10)
  const [emailID, setEmailID] = useState(null)
  const [isRefresh, setIsRefresh] = useState(true)
  const [editData, setEditData] = useState(null)
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const [role, setRole] = useState(CLIENT)

  const openDeleteModal = () => setIsDeleteModalOpen(!isDeleteModalOpen)
  const toggleModal = () => setShowModal(!showModal)

  useEffect(() => {
    if (!isRefresh) {
      return
    }
    getEmailData()
  }, [currentPage, pagesize, isRefresh, role])

  const columns = [
    {
      title: 'No',
      render: (value, item, index) => (currentPage - 1) * pagesize + (index + 1)
    },
    {
      title: 'Subject',
      dataIndex: 'subject',
      ellipsis: true,
      render: (text) =>
        text ? (
          <span className="capitalize-first-letter" title={text}>
            {text}
          </span>
        ) : (
          '-'
        )
    },
    {
      title: 'Message',
      dataIndex: 'body',
      ellipsis: true,
      render: (text) =>
        text ? (
          <span className="capitalize-first-letter" title={text}>
            {text}
          </span>
        ) : (
          '-'
        )
    },
    {
      title: 'Action',
      render: (record) => (
        <div className="d-flex align-items-center">
          <Link
            className="btn-action-icon me-2 edit_icon_div"
            onClick={(event) => {
              event.stopPropagation()
              setEmailID(record.template_id)
              const filtered = templatesData?.templates.find((template) => template?.template_id === record?.template_id)
              setEditData(filtered)
              toggleModal()
            }}
          >
            <i className="fe fe-edit d-flex align-items-center justify-content-center" style={{ color: 'primary' }}>
              <FeatherIcon icon="edit" className="icon-primary" />
            </i>
          </Link>
          <Link
            className="btn-action-icon delete_icon_div"
            onClick={(event) => {
              event.stopPropagation()
              setEmailID(record.template_id)
              openDeleteModal()
            }}
          >
            <i className="fe fe-trash-2 d-flex align-items-center justify-content-center">
              <FeatherIcon icon="trash-2" color="red" />
            </i>
          </Link>
        </div>
      )
    }
  ].filter(Boolean)

  const visibleColumns = hasAccess('addEditDeleteEmailTemplate', getUserRole()) ? columns : columns.filter((column) => column.title !== 'Action')

  const getEmailData = () => {
    changeLoader(true)
    const payload = {
      page: currentPage || 1,
      limit: pagesize,
      sort_column: 'created_at',
      sort_order: 'DESC',
      role: role,
      template_type: 'EMAIL'
    }
    dispatch(getAllTemplate(payload))
      .then(({ payload }) => {
        if (payload?.status === 200) {
          changeLoader(false)
          setIsRefresh(false)
        } else {
          errorToast(payload?.data?.status_message || 'Somthing went wrong!')
          changeLoader(false)
          setIsRefresh(false)
        }
      })
      .catch(() => {
        setIsRefresh(false)
        changeLoader(false)
      })
  }

  const handlePagination = async (page, pageSize) => {
    setCurrentPage(page)
    setPagesize(pageSize)
    setIsRefresh(true)
  }

  const onDelete = () => {
    setIsRefresh(false)
    if (emailID) {
      changeLoader(true)
      dispatch(deleteTemplate(emailID)).then(({ payload, error }) => {
        if (payload?.status === 200) {
          templatesData?.currentRecords === 1 && setCurrentPage(currentPage - 1)
          changeLoader(false)
          setIsRefresh(true)
          openDeleteModal()
          successToast(payload?.data?.status_message || 'Success!')
        } else {
          openDeleteModal()
          errorToast(payload?.data?.status_message || error?.message)
          changeLoader(false)
        }
      })
    }
  }

  const onAddEmail = () => {
    setEditData(null)
    setEmailID(null)
    toggleModal()
  }

  return (
    <div className="page-wrapper email-cleaners">
      <div className="content container-fluid">
        <div className="page-header">
          <div className="content-page-header">
            <h5>Emails Clients / Cleaners</h5>
            <div className="list-btn">
              <ul className="filter-list">
                <li>
                  <Button className="btn btn-filters w-auto popup-toggle" onClick={() => navigate('/emails/send-email', { state: role })}>
                    Send Email
                  </Button>
                </li>

                {hasAccess('addEditDeleteEmailTemplate', getUserRole()) && (
                  <li>
                    <Button className="btn btn-primary" onClick={() => onAddEmail()}>
                      Add Email Template
                    </Button>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <div className="table-card-div">
              <div className="card-table">
                <div className="card-body purchase">
                  <div className="list-btn d-flex mb-2" style={{ justifyContent: 'flex-end' }}>
                    <Nav className="d-flex gap-1">
                      <Nav.Item
                        className={`btn btn-small ${role === CLIENT ? 'toggle-button-sky sky_btn' : 'toggle-common-outline-btn common-outline-btn'}`}
                        onClick={() => {
                          if (role === CLIENT) {
                            return
                          }
                          setRole(CLIENT)
                          handlePagination(1, pagesize)
                        }}
                      >
                        <Nav.Link className={`text p-0 custom-link`} eventKey="client">
                          Client
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item
                        className={`btn btn-small ${role === CLEANER ? 'toggle-button-sky sky_btn' : 'toggle-common-outline-btn common-outline-btn'}`}
                        onClick={() => {
                          if (role === CLEANER) {
                            return
                          }
                          setRole(CLEANER)
                          handlePagination(1, pagesize)
                        }}
                      >
                        <Nav.Link className={`text p-0 custom-link`} eventKey="cleaners">
                          Cleaners
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>
                  </div>
                  <div className="table-responsive table-hover">
                    <Table
                      rowKey={(record) => record?.id}
                      onRow={() => {
                        return {
                          className: 'clickable-row'
                        }
                      }}
                      pagination={{
                        total: templatesData?.totalRecords,
                        defaultPageSize: templatesData?.limit || 10,
                        defaultCurrent: templatesData?.currentPage || 1,
                        current: currentPage,
                        pageSize: pagesize,
                        showSizeChanger: true,
                        pageSizeOptions: [10, 25, 50, 100],
                        onChange: (page, pageSize) => handlePagination(page, pageSize),
                        itemRender: itemRender
                      }}
                      columns={visibleColumns}
                      scroll={templatesData?.length > 0 ? { x: true } : false}
                      dataSource={templatesData?.templates || []}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <CustomModal isOpen={showModal} toggle={toggleModal} title={editData ? `Edit Email Template` : `Add Emails Template`}>
          <EmailAddEditModal toggle={toggleModal} setIsRefresh={setIsRefresh} editData={editData} ID={emailID} role={role} />
        </CustomModal>
        {isDeleteModalOpen && (
          <DeletePopup isDeleteModalOpen={isDeleteModalOpen} toggle={openDeleteModal}>
            <div className="multi_btn_div">
              <button type="button" className="btn common-outline-btn w-100" onClick={() => setIsDeleteModalOpen(false)}>
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-danger common-field-btn w-100"
                onClick={(e) => {
                  e.preventDefault()
                  setEmailID()
                  onDelete()
                }}
              >
                Delete
              </button>
            </div>
          </DeletePopup>
        )}
      </div>
    </div>
  )
}

export default Emails
